import { imagesBench } from 'api';
import {
  GET_IMAGES,
  UPDATE_IMAGES,
  UPLOAD_IMAGES,
  GET_ID_VEHICLE,
  GET_VEHICLE_BY_ID,
  SET_PROPERTY,
  UPDATE_CAMPAIGN_IMAGES,
  GET_CAMPAIGNS_ID,
  UPDATE_MASSIVE
} from 'store/actions/imagesBench';
import { UI_SET_LIST_ID_OPTIONS } from 'store/actions/ui';

export default {
  [GET_ID_VEHICLE]: ({ commit }, { filters }) =>
    new Promise((resolve, reject) => {
      imagesBench.getIdVehicle(filters).then(
        resp => {
          const idsVehicle = resp.data || [];
          commit(
            `ui/${UI_SET_LIST_ID_OPTIONS}`,
            { property: 'imagesBenchFilter.listIdVehicleOptions', idsVehicle },
            { root: true }
          );
          resolve(idsVehicle);
        },
        err => {
          reject(err.response.data);
        }
      );
    }),
  [GET_VEHICLE_BY_ID]: ({ commit }, { idVehicle }) =>
    new Promise((resolve, reject) => {
      imagesBench.getVehicleById(idVehicle).then(
        resp => {
          const vehicleInformation = resp.data;
          commit(SET_PROPERTY, {
            field: 'vehicleInformation',
            value: vehicleInformation
          });
          resolve(vehicleInformation.vehicleId);
        },
        err => {
          reject(err.response.data);
        }
      );
    }),
  [GET_IMAGES]: ({ commit }, idVehicle) =>
    new Promise((resolve, reject) => {
      imagesBench.getImages(idVehicle).then(
        resp => {
          const data = resp.data || [];
          commit(UPDATE_IMAGES, data);
          resolve();
        },
        err => {
          reject(err.response.data);
        }
      );
    }),
  [UPLOAD_IMAGES]: ({ commit }, { idVehicle, images }) =>
    new Promise((resolve, reject) => {
      imagesBench.uploadImages({ idVehicle, images }).then(
        resp => {
          const data = resp.data || [];
          commit(UPDATE_IMAGES, data);
          resolve();
        },
        err => {
          reject(err.response.data);
        }
      );
    }),
  [GET_CAMPAIGNS_ID]: (_, { vehicleId }) =>
    new Promise((resolve, reject) => {
      imagesBench.getCampaignId({ vehicleId }).then(
        resp => {
          const data = resp.data || [];
          resolve(data);
        },
        err => {
          reject(err.response.data);
        }
      );
    }),
  [UPDATE_CAMPAIGN_IMAGES]: (_, { campaignId, images }) =>
    new Promise((resolve, reject) => {
      imagesBench.updateCampaignImages({ campaignId, images }).then(
        resp => {
          const data = resp.data || [];
          resolve(data);
        },
        err => {
          reject(err.response.data);
        }
      );
    }),
  [UPDATE_MASSIVE]: ({ commit }, { campaignIds, images }) =>
    new Promise((resolve, reject) => {
      imagesBench.updateMassive({ campaignIds, images }).then(
        resp => {
          const data = resp.data || [];
          commit(UPDATE_IMAGES, data);
          resolve();
        },
        err => {
          reject(err.response.data);
        }
      );
    })
};
